module.exports = __webpack_public_path__ + "static/media/laravel.5200009c.png";